// Register React and related utilities for use in the asset pipeline
window.React = require("react");
window.ReactDOM = require("react-dom");
var ReactDOMClient = require("react-dom/client");
// Support component names relative to this directory:
var componentRequireContext = require.context(
  "components",
  true,
  /^(?!.*(?:__tests__|\.test\.)).*$/
);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);


window.HomeCalendar = require("components/HomeCalendar").default;
window.SiteFooter = require("components/Footer").default;

// React Router app shell — mounts into #react-app-root in the layout.
var App = require("../App").default;
document.addEventListener("DOMContentLoaded", function () {
  var reactAppRoot = document.getElementById("react-app-root");
  if (reactAppRoot) {
    var root = ReactDOMClient.createRoot(reactAppRoot);
    root.render(React.createElement(App));
  }
});
